import { isSessionExpiryResponse } from '@/auth/token-interceptor';
import { reportApiError } from '@/lib/observability/faro-client';
import type { ErrorCode } from '@restaurant/types';

/**
 * Expected outcomes, not faults — filing these buries real errors, since the
 * Grafana FrontendErrors rule alerts per event with no grouping (same reasoning
 * as IGNORED_CLIENT_ERRORS in @restaurant/types). Codes rather than statuses:
 * plenty of 409s are faults. Typed as ErrorCode so a typo fails to compile
 * instead of silently never matching.
 */
const NON_FAULT_ERROR_CODES: ReadonlySet<string> = new Set<ErrorCode>([
  'order.alreadyConfirmed',
  'order.alreadyCancelled',
]);

export function reportFailedResponse(url: string, response: Response, body: unknown): void {
  if (isSessionExpiryResponse(response)) return;
  const headerTraceId = response.headers.get('x-trace-id') ?? undefined;
  const b = body && typeof body === 'object' ? (body as Record<string, unknown>) : {};
  const traceId = (typeof b.traceId === 'string' ? b.traceId : undefined) ?? headerTraceId;
  const code = typeof b.code === 'string' ? b.code : undefined;
  const detail = typeof b.message === 'string' ? b.message : undefined;
  if (code && NON_FAULT_ERROR_CODES.has(code)) return;
  reportApiError({
    message: detail ?? code ?? `HTTP ${response.status}`,
    url,
    status: response.status,
    traceId,
  });
}

export function reportTransportFailure(url: string, err: unknown): void {
  reportApiError({
    message: err instanceof Error ? err.message : String(err),
    url,
    status: 0,
    cause: err,
  });
}
